(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["signup-promo"] && !window.DesignMode) return;
  try {
    
(function() {
  // Find the button in this section
  const trigger = document.querySelector('.signup-promo-wrapper .signup-promo-klaviyo-trigger');
  
  // Debug: Check if the button is found
  if (!trigger) {
    console.error('Signup promo button not found. Selector: .signup-promo-wrapper .signup-promo-klaviyo-trigger');
    return;
  }
  
  // Debug: Confirm the script is running
  console.log('Signup promo script loaded, button found:', trigger);

  // Add click event listener
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    console.log('Signup promo button clicked, triggering Klaviyo form UuMf2F');
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UuMf2F']);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
